import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { ProgressBar, Step } from "react-step-progress-bar";

import "react-step-progress-bar/styles.css";
import "./StepProgressBar.scss"
import messages from "../../assets/i18n";
import { Row } from "react-bootstrap";

class StepProgressBar extends Component {
	constructor() {
		super();
		this.state = {
			percent: 0,
			firstStepStatus: "",
			secondStepStatus: "",
			thirtyStepStatus: "",
		};
	}

	componentDidMount() {
		const { firstStep, secondStep, thirtyStep } = this.props;
		this.setState({
			firstStepStatus: firstStep,
			secondStepStatus: secondStep,
			thirtyStepStatus: thirtyStep,
		});

		if (firstStep === true && secondStep === true) {
			this.setState({ percent: 100 });
		} else if (firstStep === true) {
			this.setState({ percent: 50 });
		}
	}


	componentDidUpdate(prevProps, prevState) {
		const { firstStep, secondStep, thirtyStep } = this.props;

		if (firstStep !== prevProps.firstStep && firstStep === "") {
			this.setState({
				percent: 0,
				firstStepStatus: "",
				secondStepStatus: "",
				thirtyStepStatus: "",
			});
		}

		if (firstStep !== prevProps.firstStep) {
			if (firstStep === true) {
				this.setState({
					firstStepStatus: firstStep,
					secondStepStatus: 'loading'
				})
				for (let i = 0; i < 45; i++) {
					if (secondStep !== "") {
						this.setState({ percent: 50 });
						break;
					}
					setTimeout(() => {
						this.setState({ percent: i });
					}, i * 40);
				}
			} else if (firstStep === false) {
				this.setState({
					firstStepStatus: firstStep
				})
			}
		}

		if (secondStep !== prevProps.secondStep && firstStep === true) {
			this.setState({
				percent: 50,
				secondStepStatus: secondStep
			})
			if (secondStep === true) {
				this.setState({
					thirtyStepStatus: 'loading'
				})
				for (let i = 50; i < 90; i++) {
					if (thirtyStep !== "") {
						this.setState({
							percent: 100,
							thirtyStepStatus: thirtyStep
						});
						break;
					}
					setTimeout(() => {
						this.setState({ percent: i });
					}, i * 40);
				}
			}
		}

		if (thirtyStep !== prevProps.thirtyStep) {
			if (thirtyStep !== "") {
				this.setState({
					percent: 100,
					thirtyStepStatus: thirtyStep
				});
			}
		}

	}

	render() {

		const { lang } = 	this.props

		return (
			<ProgressBar
				percent={this.state.percent}
				filledBackground="linear-gradient(to right, #7efc87, #04aa10)"
			>
				<Step transition="scale">
					{({ accomplished }) => {
						const { firstStepStatus } = this.state;
						let stepCircle = ""
						let stepStatus = ""
						if (firstStepStatus === true) {
							stepCircle = " load-complete"
							stepStatus = " success"
						} else if (firstStepStatus === false) {
							stepCircle = " load-error"
							stepStatus = " error"
						}
						return (
							<Row className="status">
								<div className="step-status">
									<div className={`circle${stepCircle}`}>
										<div className={`checkmark${stepStatus}`}></div>
									</div>
								</div>
								<div className="text">
									<span className={stepStatus}>{messages[lang].fileValidation}</span>
								</div>
							</Row>
						)
					}}
				</Step>
				<Step transition="scale">
					{({ accomplished }) => {
						const { firstStepStatus, secondStepStatus } = this.state;
						let stepCircle = ""
						let stepStatus = ""
						if (secondStepStatus === "loading") {
							stepCircle = " circle-loader"
							stepStatus = " "
						} else if (firstStepStatus === true && secondStepStatus === false) {
							stepCircle = " load-error"
							stepStatus = " error"
						} else if (firstStepStatus === true && secondStepStatus === true) {
							stepCircle = " load-complete"
							stepStatus = " success"
						}
						return (
							<Row className="status">
								<div className="step-status">
									<div className={`circle${stepCircle}`}>
										<div className={`checkmark${stepStatus}`}></div>
									</div>
								</div>
								<div className="text">
									<span className={stepStatus}>{messages[lang].tradeValidation}</span>
								</div>
							</Row>
						)
					}}
				</Step>
				<Step transition="scale">
					{({ accomplished }) => {
						const { firstStepStatus, secondStepStatus, thirtyStepStatus } = this.state;
						let stepCircle = ""
						let stepStatus = ""
						if (thirtyStepStatus === "loading") {
							stepCircle = " circle-loader"
							stepStatus = ""
						} else if (secondStepStatus === true && thirtyStepStatus === false) {
							stepCircle = " load-error"
							stepStatus = " error"
						} else if (firstStepStatus === true && secondStepStatus === true && thirtyStepStatus === true) {
							stepCircle = " load-complete"
							stepStatus = " success"
						}
						return (
							<Row className="status">
								<div className="step-status">
									<div className={`circle${stepCircle}`}>
										<div className={`checkmark${stepStatus}`}></div>
									</div>
								</div>
								<div className="text">
									<span className={stepStatus}>{messages[lang].taxValidation}</span>
								</div>
							</Row>
						)
					}}
				</Step>
			</ProgressBar>

		);
	}
}
StepProgressBar.propTypes = {
	firstStep: PropTypes.oneOf(["", true, false]),
	secondStep: PropTypes.oneOf(["", true, false]),
	thirtyStep: PropTypes.oneOf(["", true, false]),
};

const mapStateToProps = state => ({
	lang: state.language.name
});

export default connect(mapStateToProps)(StepProgressBar);